<template>
  <div>
    <div class="scene" :key="index" v-for="(page, index) in pages">
      <div class="left">
        <p class="label" v-html="page.label" />
        <p class="detail" v-html="page.detail" />
      </div>
      <div class="right">
        <img class="topic" :src="page.topic" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'scene',
  data() {
    return {
      pages: [
        { prop: 'security', image: 'scene1.png', label: this.$t('Home.scene.static.security.label'), detail: this.$t('Home.scene.static.security.detail') },
        { prop: 'privacy', image: 'scene2.png', label: this.$t('Home.scene.static.privacy.label'), detail: this.$t('Home.scene.static.privacy.detail') },
        { prop: 'extension', image: 'scene3.png', label: this.$t('Home.scene.static.extension.label'), detail: this.$t('Home.scene.static.extension.detail') }
      ]
    }
  },
  created() {
    this.pages.forEach(obj => {
      obj.topic = require('@/assets/' + obj.image)
    })
  }
}
</script>

<style scoped>
.scene {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
}

.scene .left {
  width: 100%;
  height: 10rem;
  padding: 0 2rem;
}
.scene .right {
  width: 100%;
  height: 30rem;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.left .label {
  font-size: 3.25rem;
  line-height: 4rem;
}
.left .detail {
  font-size: 1.6rem;
  line-height: 2.2rem;
}

.right .topic {
  height: 100%;
}
</style>
